// src/conndb.js
import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL?.trim();
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim();

if (!url || !/^https?:\/\//i.test(url)) {
  throw new Error("VITE_SUPABASE_URL mancante/non valida (es. https://xxxx.supabase.co)");
}
if (!anonKey) {
  throw new Error("VITE_SUPABASE_ANON_KEY mancante");
}

const supabase = createClient(url, anonKey, {
  auth: { persistSession: true, autoRefreshToken: true },
});

export default supabase;
